import { BitrixVue, reactive } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { VplRouter } from 'vpl.tas';
import { findGetParameter, setCookie, getCookie } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';
import { CatalogCard } from 'vpl.tas';
import { showCatalogPreloader, hideCatalogPreloader  } from 'vpl.tas';

export const ComparePage = {
    components: {
        ItemEditBtns,
        CatalogCard
    },
    props: {
        structKey: [String, Number]
    },
    data(){
        return {
            properties: [],
            difference: false
        }
    },
    updated(){
        this.setSlider();
    },
    mounted(){
        this.setCompareItems();
    },
    methods: {
        setCompareItems(){

            let existIds = [];
            for(let i in this.compare){
                existIds.push(+this.compare[i].ID);
            }

            let propObj = {}, propArr = [];
            //сбор свойств
            for(let i in this.struct[this.structKey].componentData.ITEMS){

                let item = this.struct[this.structKey].componentData.ITEMS[i];

                if(existIds.indexOf(item.ID) < 0) continue;

                for(let j in item.DISPLAY_PROPERTIES){
                    let prop = item.DISPLAY_PROPERTIES[j];
                    if(!propObj[prop.CODE]){
                        propObj[prop.CODE] = {NAME: prop.NAME, SORT: prop.SORT};
                    }
                }
            }
            //уникальные свойства в объект
            for(let i in propObj){
                propArr.push({NAME: propObj[i].NAME, CODE: i, SORT: propObj[i].SORT, VALUES: []});
            }
            //сбор значений свойств
            for(let i in this.struct[this.structKey].componentData.ITEMS){
                let item = this.struct[this.structKey].componentData.ITEMS[i];

                if(existIds.indexOf(item.ID) < 0) continue;

                for(let j in propArr){
                    if(item.DISPLAY_PROPERTIES[propArr[j].CODE]){
                        propArr[j].VALUES.push(item.DISPLAY_PROPERTIES[propArr[j].CODE].VALUE);
                    }else{
                        propArr[j].VALUES.push('');
                    }
                }
            }
            //пометка различий свойств
            for(let i in propArr){
                let hasDiff = false;
                let val;
                for(let j in propArr[i].VALUES){

                    if(val === undefined){
                        val = propArr[i].VALUES[j];
                    }else if(val != propArr[i].VALUES[j]){
                        hasDiff = true;
                        break;
                    }
                }
                propArr[i].DIFF = hasDiff;
            }
            //сортировка по индексу
            propArr.sort((a, b) => a.SORT - b.SORT);

            this.properties = propArr;

            this.setSlider();
        },
        clearCompare(){
            $.ajax({
                url: '/ajax/compare.php',
                method: 'POST',
                data: {'clear': 'Y'},
                success: () => {
                    this.struct[this.structKey].componentData.ITEMS = {};
                    this.properties = [];
                    this.compare = {};
                }
            });
        },
        changeDifference(){
            this.difference = !this.difference;
        },
        setSlider(){
            var compareSliderMain = new Swiper(".js-compare-slider", {
                loop: false,
                spaceBetween: 20,
                slidesPerView: 4,
                grabCursor: true,
                navigation: {
                  nextEl: ".js-compare-next",
                  prevEl: ".js-compare-prev"
                },
                pagination: {
                  el: ".js-compare-pag",
                  type: "bullets",
                  clickable: true
                },
                breakpoints: {
                  320: {
                    slidesPerView: 2,
                    spaceBetween: 7
                  },
                  768: {
                    slidesPerView: 3,
                    spaceBetween: 20
                  },
                  1200: {
                    slidesPerView: 4,
                    spaceBetween: 20
                  }
                },
                on: {
                    init: () => {
                        this.setCharWidth();
                    },
                    slideChange:  () => {
                        var cardWidth = $(".js-compare-slider").find(".js-card")[0].offsetWidth,
                            activeIndex = compareSliderMain.activeIndex,
                            cardMargin = +$(".js-compare-slider").find(".swiper-slide").css("margin-right").replace("px", "");

                        this.setCharWidth();

                        if (activeIndex >= 1) {
                            $(".js-chars-container").css("transform", "translateX(calc(-" + Math.round((cardWidth + cardMargin) * activeIndex) + "px))");
                            $(".js-chars-name").css("left", "calc(" + Math.round((cardWidth + cardMargin) * activeIndex) + "px)");
                        } else {
                            $(".js-chars-container").css("transform", "translateX(0px)");
                            $(".js-chars-name").css("left", "0px");
                        }

                        compareSliderMain.pagination.render();
	                    compareSliderMain.pagination.update();
                    }
                }
            });
        },
        setCharWidth(){
            if ($(".js-compare-slider").length) {
              let cardWidth = $(".js-compare-slider").find(".js-card")[0].offsetWidth;
              $(".compare-chars__list-item-value").css("min-width", cardWidth + "px");
            }
        },
        compareProcess(){
            let existIds = [];
            for(let i in this.compare){
                existIds.push(+this.compare[i].ID);
            }

            const newItems = {};
            for(let i in this.struct[this.structKey].componentData.ITEMS){
                if(existIds.indexOf(+this.struct[this.structKey].componentData.ITEMS[i].ID) >= 0){
                 newItems[i] = this.struct[this.structKey].componentData.ITEMS[i];
                }
            }

            // Присваиваем новый объект
            this.struct[this.structKey].componentData.ITEMS = newItems;

            // Обновляем список свойств
            this.setCompareItems();
        },
        displayPropVal(val){
            if(Array.isArray(val)){
                return val.join(', ');
            }else{
                return val;
            }
        }
    },
    computed: {
        ...mapState(vplSiteStore, ['SITE_TEMPLATE_PATH', 'templateData', 'struct', 'compare'])
    },
    template: `

<section class="compare-nav js-compare-page">
    <div v-if="this.struct[this.structKey].componentData.ITEMS && Object.keys(this.struct[this.structKey].componentData.ITEMS).length" class="container">
        <div class="compare-nav__top">
            <div class="compare-nav__clear">
                <a href="#" @click.prevent="clearCompare()" class="compare-nav__clear-btn">
                    <div class="compare-nav__clear-btn-icon">
                        <svg class="ico ico-basket ico-solo" width="20" height="19" aria-hidden="true"><use xlink:href="#ico-basket"></use></svg>
                    </div>
                    <div class="compare-nav__clear-text">
                        Очистить всё
                    </div>
                </a>
            </div>
            <div class="compare-nav__bottom">
                <div class="compare-nav__btn" @click="changeDifference()" :class="{'is-active': this.difference}">
                    <span class="compare-nav__btn-container">
                        <span class="compare-nav__btn-value"></span>
                    </span>
                    Только отличия
                </div>
                <div class="section__nav-arrows">
                    <div class="swiper-button-prev slider-btn js-compare-prev" >
                        <svg class="icon icon-arrow-prev"><use xlink:href="#icon-arrow-prev"></use></svg>
                    </div>
                    <div class="swiper-button-next slider-btn js-compare-next">
                        <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                    </div>
                </div>
            </div>
        </div>
        <div class="compare-sliders">
            <div class="compare-sliders__top">
                <div class="swiper compare-slider__nav js-compare-slider">
                    <div class="swiper-wrapper">

                        <div v-for="item in this.struct[this.structKey].componentData.ITEMS" class="swiper-slide">
                            <CatalogCard :item="item" @compare-process="compareProcess" />
                        </div>
                    </div>
                    <div class="swiper-pagination js-compare-pag"></div>
                </div>
            </div>
            <div class="compare-sliders__bottom-wp">
                <div class="compare-sliders__bottom js-chars-container">
                    <ul class="compare-chars__list">

                        <template v-for="prop in this.properties">
                            <li v-if="this.difference == false || prop.DIFF == true" class="compare-chars__list-item">
                                <span class="compare-chars__list-item-name js-chars-name">
                                    {{ prop.NAME }}
                                </span>
                                <div class="compare-chars__list-items">
                                    <div class="compare-chars__list-items-wp">

                                        <span v-for="val in prop.VALUES" class="compare-chars__list-item-value">{{ this.displayPropVal(val) }}</span>
                                    </div>
                                </div>
                            </li>
                        </template>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="container">
        <div class="fav-list">
            <p>Ваш список сравнения пуст</p>
        </div>
    </div>
</section>
    `
}